module.exports = __webpack_public_path__ + "media/components/utils/fonts/Gotham-Thin-3ef053cb91518bf69f6700263cb891f8.otf";